import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Context from './globalStates';
import List from "../sources/variables/companies.json";
import { encryptData, decryptData } from '../helper/helper';


const STORAGE_KEY = 'APP_CONTEXT';

const getDecryptedContext = () => {
  const enc = sessionStorage.getItem(STORAGE_KEY);
  if (!enc) return {};
  try {
    return JSON.parse(decryptData(enc)) || {};
  } catch {
    console.error('+++ Failed to decrypt session context');
    return {};
  }
};


const ProviderContext = ({ children }) => {

  const [state, setState] = useState({
    cepNo: null,
    tc: null,
    step: null,
    token: null,
    contextReady: false,
  });

  useEffect(() => {
    const decrypted = getDecryptedContext();
    setState(prev => ({ ...prev, ...decrypted, contextReady: true, }));
  }, []);

  const saveToStorage = (updates) => {
    setState(prev => {
      const newState = { ...prev, ...updates };
      sessionStorage.setItem(STORAGE_KEY, encryptData(JSON.stringify(newState)));
      return newState;
    });
  };

  const setCepNo = (raw) => saveToStorage({ cepNo: raw });
  const setTc = (raw) => saveToStorage({ tc: raw });
  const setStep = (raw) => {
    const value = raw !== null && raw !== undefined ? String(raw) : null;
    saveToStorage({ step: value });
  };
  const setToken = (raw) => saveToStorage({ token: raw });

    const slugify = useCallback((text) => {
      return text.toString()
    }, []);

    // remove turkish characters from a string
    const removeTurkishChars = useCallback((text) => {
      const turkishChars = {
        'ç': 'c',
        'ğ': 'g',
        'ı': 'i',
        'ö': 'o',
        'ş': 's',
        'ü': 'u',
        'Ç': 'C',
        'Ğ': 'G',
        'İ': 'I',
        'Ö': 'O',
        'Ş': 'S',
        'Ü': 'U'
      }
      let newText = text
      for (let key in turkishChars) {
        newText = newText.replace(key, turkishChars[key])
      }
      return newText
    }, []);

    const innerTexts = useMemo(() => {
      const locales = List.filter(x => x.id === process.env.REACT_APP_BUILDTYPE);
      return locales[0] || {};
    }, []);

    return (
      <Context.Provider value={{
        ...state,
        setCepNo,
        setTc,
        setStep,
        setToken,
        slugify,
        removeTurkishChars,
        innerTexts,
      }}>
        {children}
      </Context.Provider>
    );
}
export default ProviderContext
